module.exports = __webpack_public_path__ + "img/curve_line_2_icon.d7d495e0.svg";